var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('preview',{attrs:{"src":_vm.path}})}
var staticRenderFns = []

export { render, staticRenderFns }